module.exports = __webpack_public_path__ + "img/ic_help_disabled.5401d12c.svg";